module.exports = __webpack_public_path__ + "img/switch_gaosi.6a662aed.png";